module.exports = __webpack_public_path__ + "static/img/16areaA_5.d9d4064.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/16areaA_5.png
// module id = 1027
// module chunks = 1